import { Box } from '@mui/material';

export const AR = () => {
  return <Box sx={{ flex: 1 }}></Box>;
};
